import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "contact-us";

const GET_CONTACT_US_URL = `${prefix}/get`;
const UPDATE_CONTACT_US_URL = `${prefix}/update`;

/**
 * @func getContactUs
 * @desc get contact us data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} contact us object
 */
export const getContactUs = async (signal) => {
    try {
        const { data, status } = await axios.get(GET_CONTACT_US_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getContactUs");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getContactUs */

/**
 * @func updateContactUs
 * @desc update contact us
 * @author izeberg
 * @param {Object} body - update contact us body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateContactUs = async (body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_CONTACT_US_URL}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateContactUs");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateContactUs */
